import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import { ResultsMenuStoreContext } from "@state/context/results";
import { Button } from "@components/buttons";

export default observer(function ResultsSearchBar() {
	const { t } = useTranslation();
	const { resultsDataStore, searchBarStore } = useContext(
		ResultsMenuStoreContext
	);

	if (resultsDataStore.searchPhrase) {
		return null;
	}

	const {
		searchTerm: rawSearchTerm,
		displayValidationPopup,
		validate,
		onTermChange,
		onSubmit,
		onReset,
	} = searchBarStore;
	const { updateSearchPhrase } = resultsDataStore;

	const onKeyUp: React.KeyboardEventHandler<HTMLInputElement> = (e) => {
		const code = e.which;

		if (code === 13) {
			onSubmit({ event: e, period: "full" }, updateSearchPhrase);
		} else {
			if (code === 27) {
				onReset();
			}
			validate();
		}
	};

	const onChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
		onTermChange(e.target.value);
		validate();
	};

	return (
		<div className="card--results">
			<div className="card--results__search">
				{displayValidationPopup && (
					<div className="message--validation field-validation-error">
						<span>{t("SEARCH.INFO")}</span>
					</div>
				)}
				<input
					className="input input--med"
					data-minlen="3"
					type="search"
					value={rawSearchTerm}
					onKeyUp={onKeyUp}
					onChange={onChange}
					placeholder={`${t("SEARCH.SEARCH")}...`}
					autoComplete="off"
					autoFocus
				/>
			</div>
			<Button
				type="button"
				className="btn--med btn--accent"
				disabled={displayValidationPopup}
				onClick={(e) =>
					onSubmit({ event: e, period: "full" }, updateSearchPhrase)
				}
				btnContent={t("SEARCH.SEARCH")}
			/>
		</div>
	);
});
